<template>
  <div class="pop">
    <div class="pop-container">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">{{ titleTxt }}</span>
        </div>
        <div class="pop-close" @click="closeModal"></div>
      </div>
      <div class="pop-content">
        <div class="pop-line">
          <div class="pop-line-label">{{ $t("paygame.orderNo") }}</div>
          <div class="pop-line-text">{{ order.pay_order_no }}</div>
        </div>
        <div class="pop-line" v-if="type === 'fail'">
          <div class="pop-line-label">{{ $t("paygame.reason") }}</div>
          <div class="pop-line-text">{{ order.show_msg }}</div>
        </div>
      </div>
      <div class="btn confirm" @click="closeModal">
        <span>{{ btnTxt }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ct: "",
    };
  },
  props: ["type", "order"],
  computed: {
    btnTxt() {
      return this.type === "fail"
        ? this.$t("paygame.know")
        : `${this.$t("paygame.know")}${this.ct}`;
    },
    titleTxt() {
      return this.type === "fail"
        ? this.$t("paygame.payFail")
        : this.$t("paygame.paySuccess");
    },
  },
  methods: {
    countDown() {
      let count = 3;
      const recursionCount = () => {
        this.ct = `（${count}s）`;
        setTimeout(() => {
          count -= 1;
          if (count > -1) {
            recursionCount();
          } else {
            this.closeModal();
          }
        }, 1000);
      };
      recursionCount();
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  created() {
    if (this.type === "success") {
      this.countDown();
    }
  },
};
</script>

<style lang="scss" scoped>
.pop {
  .pop-container {
    padding-bottom: 40px;
    width: 500px;
    .pop-content {
      padding: 30px;
      .pop-line {
        padding: 8px 10px;
        display: flex;
        align-items: center;
        &-label {
          width: 120px;
        }
        &-text {
          word-break: break-word;
          line-height: 24px;
          flex: 1;
          font-size: 14px;
        }
      }
    }
    .confirm {
      margin: 0 auto;
      width: 200px;
      height: 50px;
      span {
        line-height: 50px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
}
</style>
